var path = 'src/app/hospitals/hospital-list.html';
var html = "<div page-wrapper> <h1 class=page-header>Hospitals</h1> <div loading=loading> <ul> <li ng-repeat=\"hospital in hospitals\"><a ui-sref=\"hospital({hospitalId: hospital.id})\">{{hospital.name}}</a> ({{hospital.code}})</li> </ul> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/hospitals/hospital-list.html
 ** module id = 359
 ** module chunks = 0
 **/